import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'financeiro/cadastro/categoria', ptBr);
i18next.addResourceBundle('en', 'financeiro/cadastro/categoria', en);

const CategoriaConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/cadastro/categoria',
      component: React.lazy(() => import('./Categoria')),
    },
  ],
};

export default CategoriaConfig;
